export default {
  state: {
    fields: [],
    currentForm: null
  },

  getters: {
    formBuilderFields(state) {
      return state.fields;
    },
    getCurrentFormFromState(state) {
      return state.currentForm;
    }
  },

  mutations: {
    setFormBuilderFields(state, payload) {
      state.fields = payload;
    },
    setCurrentFormToState(state, payload) {
      state.currentForm = payload;
    }
  },

  actions: {
    setFormBuilderFields({ commit }, payload) {
      commit("setFormBuilderFields", payload);
    },
    setCurrentFormToState({ commit }, payload) {
      commit("setCurrentFormToState", payload);
    }
  }
};
